import React from "react";
import CanonsOfConductEditor from "../../../Components/CanonsOfConductEditor/CanonsOfConductTextEditor";

function CanonsOfConduct() {
  return (
    <div className="race-flyer-page-wrapper">
        
      <CanonsOfConductEditor />
    </div>
  );
}

export default CanonsOfConduct;
